import { HTMLAttributes } from 'react';
import { Paper as MuiPaper, ThemeProvider } from '@mui/material';
import { Button } from '@components/index';
import * as styles from '@components/autocomplete/paper/AutocompletePaper.styles';
import { useComposeTheme } from '@theme/theme';

interface IAutocompletePaper {
  textButton?: string;
  textButtonOnClick?: () => void;
  disabled?: boolean;
}

export const AutocompletePaper = (props: IAutocompletePaper & HTMLAttributes<HTMLElement>) => {
  const { textButton, textButtonOnClick, disabled, children, ...other } = props;

  const theme = useComposeTheme('light');
  return (
    <ThemeProvider theme={theme}>
      <MuiPaper sx={styles.paperContainer} {...other}>
        {children}
        {textButton ? (
          <Button
            disabled={disabled}
            variant='text'
            onClick={textButtonOnClick}
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            sx={{ marginTop: '18px' }}
          >
            {textButton}
          </Button>
        ) : null}
      </MuiPaper>
    </ThemeProvider>
  );
};
